import { createInertiaApp } from "@inertiajs/react";
import { createElement } from "react";
import { createRoot } from "react-dom/client";
import Layout from "@/pages/Layout.jsx";
import { hydrateRoot } from "react-dom/client";

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  // title: title => title ? `${title} - App` : 'App',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob("../pages/**/*.jsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.jsx`];
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.jsx'`);
    }

    // To use a default layout, import the Layout component
    // and use the following lines.
    // see https://inertia-rails.dev/guide/pages#default-layouts
    //
    page.default.layout ||= (page) => createElement(Layout, page.props, page);

    return page;
  },

  setup({ el, App, props }) {
    if (el) {
      if (import.meta.env.SSR) {
        hydrateRoot(el, createElement(App, props));
      } else {
        createRoot(el).render(createElement(App, props));
      }
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});
